import axios from 'axios';
const base = 'fibranap';
function getAll(query = null) {
    return axios.get(base, {
        params: query
    });
}

function register(data) {
    return axios.post(base, data);
}

function getById(id) {
    return axios.get([base, id].join('/'));
}

function update(data) {
    return axios.put([base, data.id_fnap].join('/'), data);
}

function destroy(id) {
    return axios.delete([base, id].join('/'));
}

function getAllCoberturaFO() {
    return axios.get([base, 'rango/cobertura'].join('/'));
}
function registerCoberturaFO(data) {
    return axios.post([base, 'rango/cobertura'].join('/'),data);
}
const FibraNapService = {
    getAll,
    register,
    getById,
    update,
    destroy,
    getAllCoberturaFO,
    registerCoberturaFO
};
export default FibraNapService;
